import { UPDATE_USER_AUTHORIZATION } from './types';

export const authorizePhotographerUser = ({ authorization }) => ({
  type: UPDATE_USER_AUTHORIZATION,
  authorization,
});
